const { MastersContext } = require("../context/MasterContext");
const { useContext } = require("react");

const useMasters = () => useContext(MastersContext);

export default useMasters;